import { render, staticRenderFns } from "./forums-topic.vue?vue&type=template&id=9b754264&"
import script from "./forums-topic.vue?vue&type=script&lang=js&"
export * from "./forums-topic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports